import * as React from "react";
import ReusableCategory from "./ReusableCategory";

function CategoryFifteen({ tabKey, currentElement, callMethod, isPreview }) {
  return (
    <ReusableCategory
      tabKey={tabKey}
      currentElement={currentElement}
      callMethod={callMethod}
      isIncludedAttribute={"included"}
      isPreview={isPreview}
    />
  );
}

export default CategoryFifteen;